module.exports = __webpack_public_path__ + "img/star.24bd245d.svg";